import React, { Component } from 'react';
import PopularList from './PopularList';

const popularEvents = ['most_popular_events_1', 'most_popular_events_2', 'most_popular_events_3', 'most_popular_events_4', 'most_popular_events_5'];
const popularForms = ['most_popular_forms_1', 'most_popular_forms_2', 'most_popular_forms_3', 'most_popular_forms_4', 'most_popular_forms_5'];
const popularNews = ['most_popular_news_1', 'most_popular_news_2', 'most_popular_news_3', 'most_popular_news_4', 'most_popular_news_5'];
const popularPolicies = ['most_popular_policies_1', 'most_popular_policies_2', 'most_popular_policies_3', 'most_popular_policies_4', 'most_popular_policies_5']
const popularRates = ['most_popular_rates_1', 'most_popular_rates_2', 'most_popular_rates_3', 'most_popular_rates_4', 'most_popular_rates_5'];
const popularTraining = ['most_popular_training_1', 'most_popular_training_2', 'most_popular_training_3', 'most_popular_training_4', 'most_popular_training_5'];

class Sidebar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      popularResults: []
    };

    this.filterObject = this.filterObject.bind(this);

    this.popularHeaders = {'Forms': popularForms, 'Policies': popularPolicies, 'Rates': popularRates, 'News & Announcements': popularNews, 'Training': popularTraining, 'Events': popularEvents};

    this.search('/rest/get_popular_settings', true);
  }

  search (queryString, initialLoad = false) {

    fetch(queryString, {
      method: 'GET',
      credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(data => {
      this.setState({popularResults: data});
    })
  }

  filterObject(categories) {
    const filtered = Object.keys(this.state.popularResults)
      .filter(key => categories.includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: this.state.popularResults[key]
        };
      }, {});
    return filtered;
  }

  render() {
    const { results } = this.props;

    return (
      <div className={`sidebar popular-content--search-container ${results.length > 0 ? 'results-populated' : ''}`}>
          {Object.keys(this.popularHeaders).map((key) => (
              <div key={key}className="popular-category--search">
                <span className="popular-header">{key}</span>
                <PopularList object={this.filterObject(this.popularHeaders[key])} />
              </div>
            )
          )}
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/Sidebar.js